import { SkeletonLoading } from "@/main/components/shared/styles";
import * as S from "./styles";

interface ISkeletonModalBuyerManualAnswerProps {}
function SkeletonModalBuyerManualAnswer(_props: ISkeletonModalBuyerManualAnswerProps) {
	return (
		<S.SkeletonRowPart>
			<SkeletonLoading $height="80px" $forceWidth="80px" $margin="0 auto" />
			<SkeletonLoading />
			<SkeletonLoading $height="20px" $forceWidth="20px" $margin="0 auto" />
		</S.SkeletonRowPart>
	);
}

export default SkeletonModalBuyerManualAnswer;
